import React, {useEffect, useState} from "react";
import type { ContextProps } from '../../types';
import {PageTitle} from "../../Components/Landmarks";
import {LibraryVendorView} from "./LibraryVendorView";
import {locations} from "../../Utilities/Location";
import {libraryCatalogApi} from "./libraryCatalogApi";
import {emptyVendorModel} from "./libraryFactory";
import {createListFromArrayOfObjects} from "../../Utilities/Types/listUtilities";
import {emptyGuid} from "../../Utilities/commonUtilities";
import {SelectField} from "../../Components/Inputs";

export const LibraryVendorContainer = ({
                                           handleApiCall,
                                           libraryVendorId,
                                           redirect,
                                           systemType,
                                       }: ContextProps) => {
    const [vendor, setVendor] = useState<Record<string, unknown>>();
    const [vendors, setVendors] = useState<Record<string, unknown>[]>();
    const vendorList = createListFromArrayOfObjects(vendors, "vendorId", "name");

    const numericSystemType = Number(systemType);

    const handleChangeVendor = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const path = locations.LIBRARY_VENDOR.getLink([event.target.value, systemType]).to;
        redirect(path);
    }

    const handleReturn = () => redirect(locations.LIBRARY_CATALOG.getLink(systemType).to);

    const handleSaveVendor = async (vendorFromForm: Record<string, unknown>) => {
        const vendorToSave = {
            ...vendorFromForm,
            systemType: numericSystemType,
            vendorId: vendor?.vendorId 
        };
        return handleApiCall(() => libraryCatalogApi.saveVendor(vendorToSave),
            async () => {
                await handleApiCall(() => libraryCatalogApi.getVendors(numericSystemType), (results: Record<string, unknown>[]) => setVendors(results));
                handleReturn();
            });
    };

    useEffect(() => {
        const getVendors = () => {
            handleApiCall(() => libraryCatalogApi.getVendors(numericSystemType), (results: Record<string, unknown>[]) => setVendors(results));
        }

        const getVendor = () => {
            const found = vendors?.find((v: Record<string, unknown>) => v.vendorId === libraryVendorId);
            if (found) {
                setVendor({ ...found, systemType: numericSystemType });
            } else {
                setVendor({ ...emptyVendorModel, systemType: numericSystemType });
            }
        }

        if (!vendors)
            getVendors();
        else if (libraryVendorId)
            getVendor();

    }, [vendors, libraryVendorId, numericSystemType]);

    if (!vendor) return <></>;

    return <>
        <PageTitle h1={`Manage Vendors`}/>
        <SelectField
            defaultOption={"-- Create New Vendor --"}
            defaultOptionValue={emptyGuid}
            label={"Select Vendor to Manage"}
            name={'VendorList'}
            onChange={handleChangeVendor}
            options={vendorList}
            value={libraryVendorId}
        />
        <LibraryVendorView
            handleSaveVendor={handleSaveVendor}
            handleReturn={handleReturn}
            vendor={vendor}
        />
    </>;
};
